import React, { useEffect, useState } from 'react';
import { Button, Table } from '@/components/Elements';
import TableLoader from '@/components/Elements/Loader/TableLoader';
import close from '@/assets/close-circle.svg';
import { useNavigate } from 'react-router-dom';
// import { LawyerContractList } from '../types/LawyerContractList';
import Modal from 'react-responsive-modal';
import DigitalSignature from '@/features/user/routes/Contract/DigitalSignature';
import digitalSignature from '@/assets/digitalSignature.png';
import { useNotificationStore } from '@/stores/notifications';
// import { acceptOrRejectOffer, finalizeLawyer } from '../api/finalizeLawyer';
import { useGetFinalizeListing } from '../../api/finalizeListing';
import { LawyerContractList } from '../../types/LawyerContractList';
import { acceptOrRejectOffer, finalizeLawyer } from '../../api/finalizeLawyer';

const FinalizedList = ({
  page,
  changePage,
}: {
  page: string;
  changePage: (page: string) => void;
}) => {
  const { data, refetch, isLoading, isFetching } = useGetFinalizeListing({});
  const [signature, setSignature] = useState<any>('');
  const [signErr, setSignErr] = useState<boolean>(false);
  const [id, setId] = useState<any>('');
  const [open, setOpen] = useState(false);
  console.log(data);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const navigate = useNavigate();

  useEffect(() => {
    refetch();
  }, [page, refetch]);

  const handleModal = (id: string) => {
    onOpenModal();
    setId(id);
  };

  const handleSignature = async () => {
    if (!signature) {
      return setSignErr(true);
    }
    const payload = {
      finalize_request_id: id,
      lawyer_signature: signature,
    };

    const res: any = await finalizeLawyer(payload);
    if (res) {
      useNotificationStore.getState().addNotification({
        type: 'success',
        title: 'Succes',
        message: 'Signature added successfully !!',
      });
      onCloseModal();
      refetch();
    }
  };

  useEffect(() => {
    if (signature) {
      setSignErr(false);
    }
  }, [signature]);
  return (
    <>
      {isLoading || isFetching ? (
        <TableLoader />
      ) : (
        <Table<LawyerContractList>
          page={parseInt(page)}
          changePage={changePage}
          total={data?.total ?? 1}
          data={data?.all_data ?? []}
          columns={[
            {
              title: 'Inquiry Customer Name',
              field: 'customer_name',
              Cell({ entry: { customer_firstName, customer_lastName } }) {
                return <span>{customer_firstName + ' ' + customer_lastName}</span>;
              },
            },
            { title: 'Inquiry Customer Email', field: 'customer_email' },
            { title: 'Inquiry Customer No.', field: 'customer_phoneNumber' },
            // { title: 'Property Customer Name', field: 'property_project_customer_name' },
            // { title: 'Property Customer No.', field: 'property_project_customer_phone_number' },
            // { title: 'Property Customer Email.', field: 'property_project_customer_email' },
            {
              title: 'Status',
              field: 'finalized_status',
              Cell({ entry: { finalized_status } }) {
                return (
                  <>
                    {finalized_status == 'finalized by customer and lawyer' ? (
                      <span style={{ color: '#068873' }}> Signed Contract</span>
                    ) : (
                      <span style={{ color: '#ED9200' }}> Contract Sign Pending</span>
                    )}
                  </>
                );
              },
            },

            {
              title: 'Action',
              field: 'id',
              Cell({ entry: { id, finalized_status, contract_id } }) {
                return (
                  <>
                    <div className="d-flex gap-2">
                      <Button onClick={() => navigate(`/lawyer/contract-details-page/${contract_id}`)}>
                        View
                      </Button>

                      {finalized_status == 'finalized by customer and lawyer' ? (
                        <Button>Finalized</Button>
                      ) : (
                        <Button onClick={() => handleModal(id)}>Finalize</Button>
                      )}
                    </div>
                  </>

                  // <span
                  //   role="button"
                  //   tabIndex={-1}
                  //   className="icon me-2"
                  //   title="View Details"
                  //   onClick={() => navigate(`/lawyer/contract-details-page/${id}`)}
                  // >
                  //   <i className="fa-solid fa-eye"></i>
                  // </span>
                );
              },
            },
          ]}
        />
      )}

      <div className="agency-modal">
        <Modal open={open} onClose={onCloseModal} center>
          <button
            className="modal-close-button"
            onClick={onCloseModal}
            aria-label="Close"
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              background: 'none',
              border: 'none',
              fontSize: '40px',
              cursor: 'pointer',
            }}
          >
            <img src={close} className="close-circle" />
          </button>
          <section className=" agency-model">
            <h5 className="agency-title semi-bold text-black">Contract</h5>
            <div className="conteact-modal m-0" style={{ padding: '15px' }}>
              <p className="f-14 my-4">
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                Ipsum has been the industry's standard dummy text ever since For a limited time
                only, we have managed to secure an income producing six bedrooms HMO within
                proximity to Manchester City Centre. For a limited time only, we have managed to
                secure an income producing six bedrooms HMO within proximity to Manchester City
                Centre.
              </p>

              <div className="signatureDiv mt-3">
                <p className="semi-bold f-18">Signature</p>
                <div className="beforeSign">
                  {signature ? (
                    <>
                      <img className="sign-preview" src={signature} alt="sasa" />
                    </>
                  ) : (
                    <>
                      <img className="signature-preview-2" src={digitalSignature} alt="sign" />
                      <span className="spanTxt">Signature will appear here</span>
                    </>
                  )}
                </div>
                {signErr && <p className="text-danger">Please add the signature</p>}
                <div className="d-flex justify-content-center  signature-contract">
                  <DigitalSignature setSignature={setSignature} />
                  <button
                    type="button"
                    className="btn btn-secondary mt-3 ml-3"
                    style={{ marginBottom: '34px' }}
                    onClick={() => setSignature(null)}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </section>
          <div className="sub-btns d-flex gap-3 mt-4 align-items-center justify-left">
            <Button className="rounded-full pink-btn" onClick={() => handleSignature()}>
              Submit
            </Button>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default FinalizedList;
